var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticStyle: { display: "inline-block", height: "100%" } },
    [
      _vm._v("\n   My credits: "),
      _c("strong", [_vm._v(_vm._s(_vm.creditsAmount))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }